import { Component, Vue } from 'vue-property-decorator';
import PrizeManagement from './prize-management/PrizeManagement.vue';
import RewardPeriod from './reward-period/RewardPeriod.vue';

enum TabItem {
  REWARD_PERIOD = 'Reward Periods',
  PRIZES = 'Prizes'
}

@Component({
  components: { PrizeManagement, RewardPeriod }
})
export default class RewardManagement extends Vue {
  private tab = null;
  private readonly tabItems = [
    { title: TabItem.REWARD_PERIOD, component: RewardPeriod },
    { title: TabItem.PRIZES, component: PrizeManagement }
  ];
}
